import FitScreenIcon from "@mui/icons-material/FitScreen";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { Box, IconButton, Tooltip } from "@mui/material";
import { MAX_ZOOM, MIN_ZOOM } from "../hooks/useZoom";
import { EditableValue } from "./EditableValue";

const iconBtnSx = {
  color: "#5C6B7A",
  "&:not(:disabled):hover": { color: "#002A5C" },
  "&.Mui-disabled": { color: "#C4CDD8" },
};

interface Props {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomReset: () => void;
  onZoomAndRecenter: (zoom: number) => void;
}

export function ZoomControls({
  zoom,
  onZoomIn,
  onZoomOut,
  onZoomReset,
  onZoomAndRecenter,
}: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.25,
        bgcolor: "#EDF1F7",
        borderRadius: 2,
        px: 0.5,
      }}
    >
      <Tooltip title="Zoom out">
        <span>
          <IconButton
            onClick={onZoomOut}
            disabled={zoom <= MIN_ZOOM}
            size="small"
            sx={iconBtnSx}
          >
            <ZoomOutIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <EditableValue
        display={`${Math.round(zoom * 100)}%`}
        initialDraft={String(Math.round(zoom * 100))}
        onCommit={(v) => {
          const n = parseInt(v.replace("%", ""));
          if (!isNaN(n))
            onZoomAndRecenter(Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, n / 100)));
        }}
        minWidth={48}
      />
      <Tooltip title="Zoom in">
        <span>
          <IconButton
            onClick={onZoomIn}
            disabled={zoom >= MAX_ZOOM}
            size="small"
            sx={iconBtnSx}
          >
            <ZoomInIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Fit page">
        <IconButton
          onClick={onZoomReset}
          size="small"
          sx={{ color: "#5C6B7A", "&:hover": { color: "#002A5C" } }}
        >
          <FitScreenIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
